import React from 'react';
import Modal from '../../../components/Modal/modal';
import { useLang } from '../../../util/lang';
import './ExpandingModal.css';
const ExpandingModal = ({ open, onClose, childrenFunc }) => {
    // 处方问题展开弹窗，统一控制弹窗内容和 OK 按钮样式。
    const getLang = useLang();
    return (
        <Modal
            open={open}
            handleClose={onClose}
            btnLabel={{ closeBtnLabel: getLang(':const.ok') }}
            modalSize={'xl'}
            closeButtonClassName="expandingModalOkButton"
        >
            <div className="expandingModal_content">{childrenFunc && childrenFunc()}</div>
        </Modal>
    );
};

export default ExpandingModal;
